import React from "react";
import { CheckCircle2 } from "lucide-react";
import Reveal from "@/components/Reveal";

const POINTS = [
  "FDM + SLA resin workflows under one roof",
  "Bengaluru pickup + courier delivery available",
  "Student bundles for college & STEM submissions",
  "NDA-friendly for startup prototypes",
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 sm:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10 items-center">
        <Reveal className="lg:col-span-5">
          <div className="relative aspect-[4/5] overflow-hidden border border-white/10">
            <img
              src="https://images.unsplash.com/photo-1642969164999-979483e21601?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format"
              alt="3D printer in studio"
              className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700"
            />
            <div className="absolute bottom-0 inset-x-0 p-5 bg-gradient-to-t from-black to-transparent">
              <div className="label-overline mb-1">Studio</div>
              <div className="font-display text-lg">Gunjur Village, Bengaluru</div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={140} className="lg:col-span-6 lg:col-start-7">
          <span className="label-overline">/ 04 — The studio</span>
          <h2 className="font-display text-4xl sm:text-5xl mt-6 mb-8 leading-[1.05] font-semibold tracking-tight">
            Affordable precision,<br />without the corporate markup.
          </h2>
          <p className="text-zinc-400 leading-relaxed text-lg mb-10">
            We're a small, hands-on studio in Kodathi Road, Gunjur, dedicated to
            making rapid prototyping accessible — whether you're a final-year
            engineering student, a robotics club, an architect or just someone
            with a wild Fusion 360 sketch. Every job is reviewed for
            printability before quoting.
          </p>

          <ul className="space-y-3 mb-10">
            {POINTS.map((p) => (
              <li
                key={p}
                className="flex items-start gap-3 text-sm text-zinc-300"
                data-testid={`about-point-${p.slice(0, 8)}`}
              >
                <CheckCircle2 size={18} className="text-[#FF5722] mt-0.5 shrink-0" />
                <span>{p}</span>
              </li>
            ))}
          </ul>

          <div className="grid grid-cols-2 gap-px bg-white/10 border border-white/10">
            <div className="bg-[#0A0A0C] p-6">
              <div className="font-display text-xl sm:text-2xl text-white leading-tight">
                Up to 0.05<span className="text-zinc-500 text-lg">mm</span>
              </div>
              <div className="label-overline mt-3">Layer precision</div>
            </div>
            <div className="bg-[#0A0A0C] p-6">
              <div className="font-display text-xl sm:text-2xl text-[#FF5722] leading-tight">
                Fully customisable
              </div>
              <div className="label-overline mt-3">Every design</div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
